module.exports = __webpack_public_path__ + "media/app/components/MainNav/AmericanFlag.ea7d1832.svg";